import React, { useState, useEffect } from 'react';
import { Checkbox, FormControlLabel, TextField } from '@material-ui/core';
import { handleErrorToast } from '../../../../shared/Functions';
import { TokensVService } from '../../../../../services/V2/gozer';
import { CCiframe } from './CCiframe';
import { CCProcessorEnum, PaymentConfigsVService } from '../../../../../services/V2/padre';

export function CCPayment({ billingAccountId, districtId, step, setStep, failureCallback, handleAdd, formData, setFormData, setStepName }) {
    const [ccTokens, setCCTokens] = useState<any[]>([]);
    const [tokenId, setTokenId] = useState<string>("");
    const [isTransafe, setIsTransafe] = useState<boolean>(false);

    useEffect(() => {
        if (billingAccountId && districtId) {
            PaymentConfigsVService.paymentConfigsVGetDistrictPaymentConfig(districtId)
                .then(x => setIsTransafe(x.ccProcessorId === CCProcessorEnum.PACE_TRANSAFE))
                .catch(err => failureCallback(handleErrorToast(err)))

            TokensVService.tokensVGetAll(billingAccountId)
                .then(t => setCCTokens(t))
                .catch(err => failureCallback(handleErrorToast(err)))
        }
    }, [billingAccountId, districtId])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (step === 2 && formData.paymentMethod !== "NEW") {
            if (!formData.paymentAmount || !formData.paymentMethod) {
                failureCallback("Payment Amount and Payment Method are both required.");
                setStep(1)
            } else {
                handleAdd();
            }
        } else if (step === 2 && formData.paymentMethod === "NEW") {
            if (!formData.paymentAmount || !formData.paymentMethod) {
                failureCallback("Payment Amount and Payment Method are both required.");
                setStep(1)
            } else {
                setStepName("");
            }
        }
    }, [step])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (tokenId !== "") {
            setFormData({
                ...formData,
                paymentMethod: {
                    id: tokenId
                }
            })
            setStepName("")
            setStep(3)
        }
    }, [tokenId])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (step === 3 && formData.paymentMethod && formData.paymentMethod !== "NEW") {
            handleAdd()
        } else if (formData.paymentMethod && formData.paymentMethod !== "NEW") {
            setStepName("Process Payment")
        } else if (formData.paymentMethod && formData.paymentMethod === "NEW" && step !== 3) {
            setStepName("Continue")
        }
    }, [formData])// eslint-disable-line react-hooks/exhaustive-deps

    const handleChange = event => {
        let name = event.target.name;
        let value = event.target.value;
        if (event.target.type === "checkbox") {
            value = event.target.checked;
        }

        setFormData({
            ...formData,
            [name]: value
        })
    }

    return (
        <>
            {step === 1 &&
                <>
                    <TextField
                        onChange={handleChange}
                        required={true}
                        margin="normal"
                        name="paymentAmount"
                        label="Payment Amount"
                        type="text"
                        value={formData === undefined ? null : formData.paymentAmount}
                        fullWidth
                    />
                    <TextField style={{ width: '100%', textAlign: 'left' }}
                        required={true}
                        select
                        onChange={handleChange}
                        margin="normal"
                        name="paymentMethod"
                        label="Payment Method"
                        type="string"
                        value={formData === undefined || formData.paymentMethod === undefined ? "" : formData.paymentMethod}
                    >
                        <option value="NEW">New Payment Method</option>
                        {
                            ccTokens.map(t => (
                                <option key={t.id} value={t}>
                                    {`${t.cardType} ${t.last4}`}
                                </option>
                            ))
                        }
                    </TextField>
                    {formData.paymentMethod === "NEW" &&
                        <FormControlLabel style={{ margin: '0px' }}
                            label="Save For Future Use"
                            labelPlacement="end"
                            control={
                                <Checkbox
                                    checked={(formData === undefined
                                        || formData === null || formData.savePayment === undefined ? false : formData.savePayment)}
                                    onChange={handleChange}
                                    color="primary"
                                    name="savePayment" />
                            } />
                    }
                    {formData.savePayment === true &&
                        <FormControlLabel style={{ margin: '0px' }}
                            label="Use For Autopay"
                            labelPlacement="end"
                            control={
                                <Checkbox
                                    checked={(formData === undefined
                                        || formData === null || formData.autopay === undefined ? false : formData.autopay)}
                                    onChange={handleChange}
                                    color="primary"
                                    name="autopay" />
                            } />
                    }
                </>
            }
            {!isTransafe && step === 2 && formData.paymentMethod === "NEW" &&
                <CCiframe
                    billingAccountId={billingAccountId}
                    failureCallback={failureCallback}
                    isSaved={formData.savePayment ?? false}
                    setTokenId={setTokenId} />
            }
            {/* {isTransafe && step === 2 && formData.paymentMethod === "NEW" && 
                <CCPayFrame
                    billingAccountId={billingAccountId}
                    isSaved={formData.savePayment ?? false}
                    setTokenId={setTokenId} />
            } */}
            {step === 3 &&
                <>
                </>
            }
        </>
    );
}